/*
import render from './VueRender'
render({loading: true})
const loader = loading => render({loading})
*/

import store from "../store";
import { ElMessageBox } from 'element-plus/es/components/message-box'
import {trace} from './trace'
import { i18n } from './vue-i18n'
import {
    addGlobalUncaughtErrorHandler,
    initGlobalState,
    loadMicroApp,
    prefetchApps,
    registerMicroApps,
    runAfterFirstMounted,
} from "qiankun"

const t = new Date().getTime()
window.__qiankun__ = {
  loadMicroApp,
  addGlobalUncaughtErrorHandler,
  v: t
}

prefetchApps([{
  name: 'vcommon',
  entry: '/pc/pp/common/index.html?_t=' + t
},{
  name: 'votapub',
  entry: '/pc/otapub/web/index.html?_t=' + t
}])

trace.getResources('pc-gateway')
export default function (){
    /**
     * Step1 初始化应用（可选）
     */

    const loader = loading => {
        store.commit('setLoading', loading)
    }


    /**
     * Step2 注册子应用
     */
    registerMicroApps(  
        [
            {
                name: 'common',
                entry: '/pc/bm/common/index.html?_t=' + t,
                container: '#subapp-viewport',
                loader,
                activeRule: ['/v/common/', '/v/pg/bm/common/', '/pg/bm/common/']
            },
            {
              name: 'vcommon',
              entry: '/pc/pp/common/index.html?_t=' + t,
              container: '#subapp-viewport',
              loader,
              activeRule: ['/v/vcommon/','/v/pg/pp/common/', '/pg/pp/common/']
            },
            {
              name: 'control',
              entry: '/pc/control/web/index.html?_t=' + t,
              container: '#subapp-viewport',
              loader,
              activeRule: ['/v/pg/control/', '/pg/control/']
            },
            {
                name: 'hotel',
                entry: '/pc/hotel/web/index.html?_t=' + t,
                container: '#subapp-viewport',
                loader,
                activeRule: ['/v/hotel/', '/v/pg/hotel/','/pg/hotel/']
            },
            {
                name: 'flight',
                entry:'/pc/flight/web/index.html?_t=' + t,
                container: '#subapp-viewport',
                loader,
                activeRule: ['/v/flight/', '/v/pg/flight/','/pg/flight/']
            },
            {
                name: 'train',
                entry: '/pc/train/web/index.html?_t=' + t,
                container: '#subapp-viewport',
                loader,
                activeRule: ['/v/train/', '/v/pg/train/', '/pg/train/']
            },
            {
                name: 'expense',
                entry: '/pc/expense/web/index.html?_t=' + t,
                container: '#subapp-viewport',
                loader,
                activeRule: ['/v/expense/', '/v/pg/expense/','/pg/expense/']
            },
            {
                name: 'votapub',
                entry: '/pc/otapub/web/index.html?_t=' + t,
                container: '#subapp-viewport',
                loader,
                activeRule: ['/v/votapub/', '/v/pg/otapub/', '/pg/otapub/']
            },
            {
                name: 'fexotapub',
                entry: '/pc/otapub/fex/index.html?_t=' + t,
                container: '#subapp-viewport',
                loader,
                activeRule: ['/v/fexotapub/', '/v/pg/fexotapub/', '/pg/fexotapub/']
            },
            {
                name: 'liquidation',
                entry: '/pc/oper/liquidation/index.html?_t=' + t,
                container: '#subapp-viewport',
                loader,
                activeRule: ['/v/pg/oper/liquidation/', '/pg/oper/liquidation/']
            },
            {
                name: 'risk',
                entry: '/pc/oper/risk/index.html?_t=' + t,
                container: '#subapp-viewport',
                loader,
                activeRule: ['/v/pg/oper/risk/', '/pg/oper/risk/']
            },
            {
                name: 'workflow',
                entry: '/pc/pp/workflow/index.html?_t=' + t,
                container: '#subapp-viewport',
                loader,
                activeRule: ['/pg/pp/workflow/', '/v/pg/pp/workflow/']
            },
            {
                name: 'journey',
                entry: '/pc/bi/journey/index.html?_t=' + t,
                container: '#subapp-viewport',
                loader,
                activeRule: ['/v/pg/journey/', '/pg/journey/', '/v/journey/']
            }
        ],
        {
          getTemplate: (e) => {
            console.log('e', e)
          },
            beforeLoad: [
                app => {
                    console.log('[LifeCycle] before load %c%s', 'color: green;', app.name);
                },
            ],
            beforeMount: [
                app => {
                  // window.$CS && window.$CS.initCsType()
                  trace.getResources('pc-' + app.name)
                  console.log(app)
                  console.log('[LifeCycle] before mount %c%s', 'color: green;', app.name);
                },
            ],
            afterUnmount: [
                app => {
                    console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name);
                },
            ],
        },
    );

    const {onGlobalStateChange, setGlobalState} = initGlobalState({
        user: 'qiankun',
    });

    onGlobalStateChange((value, prev) => console.log('[onGlobalStateChange - master]:', value, prev));

    setGlobalState({
        ignore: 'master',
        user: {
            name: 'master',
        },
    });


    function refresh(path) {
        ElMessageBox.confirm(
            i18n.global.t('MENUSLIDE.zi-yuan-jia-zai-shi-bai-qing-chong-shi-huo-fan-hui'),
            i18n.global.t('MENUSLIDE.ti-shi'),
            {
                confirmButtonText: i18n.global.t('MENUSLIDE.shua-xin'),
                cancelButtonText: i18n.global.t('MENUSLIDE.qu-xiao'),
                type: 'warning',
            })
            .then(() => {
                location.reload()
            })
            .catch(() => {
                // window.history.back()
            })
    }

    function checkWhiteList(e){
        const globalWhiteList = ['adguard.org']
        let isWhiteList = false
        globalWhiteList.forEach((item)=>{
            if(e.message&&e.message.includes(item)){
              isWhiteList =  true
            }
        })
        return isWhiteList
    }

    addGlobalUncaughtErrorHandler((e) => {
        console.log('addGlobalUncaughtErrorHandler', e)
        if(checkWhiteList(e)){
            console.log('checkWhiteList',e.message)
            return false
        }
        // js资源未加载到 Failed to fetch
        if(e.type === 'error' && e.error && (e.error.message === 'ChunkLoadError' || e.error.message.includes('died'))){
        // if ( (e.message&&e.message.includes('Failed to fetch')) || (e.reason && e.reason.message && e.reason.message.includes('Failed to fetch'))) {
            store.commit('setLoading', false)
            refresh()
        }
    })

    /**
     * Step3 设置默认进入的子应用
     */
    if(JSON.parse(sessionStorage.getItem('microApp')) !== 'iframe') {
        // setDefaultMountApp('/v/hotel');
    }

    runAfterFirstMounted(() => {
        console.log('[MainApp] first app mounted');
        // window.$CS && window.$CS.init()
    });
}
